import React, { PropsWithChildren } from 'react';
export function InfoMessage({ children, className }: PropsWithChildren<{ className?: string }>) {
  return <p className={`alert--warning--yellow ${className}`}>{children}</p>;
}
